import { useState } from 'react';
import { Button } from '../ui/Button.js';
import { Dialog } from '../ui/Dialog.js';

export type BulkPasteDialogProps = {
  open: boolean;
  onClose: () => void;
  onAdd: (urls: string[]) => void;
};

/** Setting up a ten-way split should not be ten clicks of "add destination". */
export function BulkPasteDialog({ open, onClose, onAdd }: BulkPasteDialogProps) {
  const [text, setText] = useState('');
  const urls = text
    .split(/[\n\r]+/)
    .map((line) => line.trim())
    .filter((line) => line !== '');

  return (
    <Dialog open={open} title="Import destinations" onClose={onClose}>
      <label htmlFor="bulk-urls" className="text-[length:var(--text-small)] text-ink-muted">
        One URL per line. They are added at 0%, so importing cannot change what live traffic is
        doing — give them their share, or press Distribute evenly.
      </label>
      <textarea
        id="bulk-urls"
        rows={8}
        autoFocus
        spellCheck={false}
        className="mt-(--space-2) w-full rounded-(--radius-md) border border-rule-strong bg-surface-raised p-(--space-3) font-mono text-[length:var(--text-small)] text-ink"
        value={text}
        onChange={(event) => setText(event.target.value)}
      />
      <div className="mt-(--space-4) flex items-center justify-between gap-(--space-3)">
        <p className="text-[length:var(--text-small)] text-ink-subtle">
          {urls.length} URL{urls.length === 1 ? '' : 's'} detected
        </p>
        <div className="flex gap-(--space-2)">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={urls.length === 0}
            onClick={() => {
              onAdd(urls);
              setText('');
              onClose();
            }}
          >
            Add {urls.length > 0 ? urls.length : ''} destination{urls.length === 1 ? '' : 's'}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
